import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireDist } from "D:\\project\\cocos-nexus\\dist\\index.js";
var distExports = requireDist();
export { distExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(distExports);